module.exports = __webpack_public_path__ + "img/960.46f28f6d.svg";